import { NextPageContext } from "next"
import { config } from "@lib/config"

export function isServer() {
  return typeof window === "undefined"
}

export const redirect = (uri: string, ctx: NextPageContext) => {
  ctx.res?.writeHead(301, {
    Location: `${config.data.prefix}${uri}`,
    "Cache-Control": "no-cache",
  })
  ctx.res?.end()
}
